import { useState, useRef, useEffect } from "react";
import { Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../CommanStyles/style.css";
import { TextCss } from "../../../GlobalCss/TextCss";

const CustomInputTextArea = ({
  isFormControl = true,
  value = undefined,
  required = false,
  disabled = false,
  label = "",
  placeholder = "",
  type = "text",
  rows = 2,
  name,
  myClassName = "",
  errorMessages = "",
  isError,
  onChange,
  onBlur = () => { },
  width = "500px",
  onKeyDown = undefined,
  cols = "",
  maxLength = undefined,
  onError = undefined,
  onClearError = undefined,
}: any) => {
  const [limitError, setLimitError] = useState<string | null>(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleChange = (event: any) => {
    const val = event.target.value;

    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    if (maxLength && val.length > maxLength) {
      const msg = `${label || "Field"} cannot exceed ${maxLength} characters`;
      setLimitError(msg);
      if (onError) {
        onError(msg);
      }

      // Hide error after 1 second
      timeoutRef.current = setTimeout(() => {
        setLimitError(null);
        if (onClearError) onClearError();
      }, 1000);

      return; // Block input
    }

    setLimitError(null);
    if (onClearError) {
      onClearError();
    }
    onChange(event);
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  let injectErrorClasses = "";

  if (typeof isError == "boolean") {
    injectErrorClasses = isError
      ? "errorBorder errorOutline"
      : "normalBorder normalOutline";
  }

  return (
    <>
      {label && (<p className={TextCss.black.sub_heading_600_14}>{label}{required &&<span className="red">*</span>}</p>)}
      {isFormControl ? (<>
        <Form.Control
          className={`${injectErrorClasses} ${myClassName}`}
          type={type}
          name={name}
          value={value}
          placeholder={placeholder}
          onBlur={onBlur}
          required={required}
          onChange={handleChange}
          disabled={disabled}
          as="textarea"
          rows={rows}
          cols={cols}
          style={{ width: width }}
          onKeyDown={onKeyDown}
        />
        {maxLength && (
          <div className="d-flex justify-content-end mt-n2 mb-2">
            <span className="sub_text grey_subtext1" style={{ fontSize: '11px', marginTop: '5px' }}>
              {String(value || "").length}/{maxLength}
            </span>
          </div>
        )}
      </>
      ) : (
        <input
          type={type}
          name={name}
          value={value}
          required={required}
          placeholder={placeholder}
          onChange={handleChange}
          onBlur={onBlur}
          className={`${injectErrorClasses} ${myClassName}`}
          disabled={disabled}
          style={{ width: width }}
          onKeyDown={onKeyDown}
        />
      )}
      {(isError || limitError) && (
        <div className="mt-2">
          <p className="errorMessageStyles">{limitError || errorMessages}</p>
        </div>
      )}
    </>
  );
};

export default CustomInputTextArea;
